import React from 'react';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import useMerchantOverrides from 'Hooks/query-hooks/merchants/useMerchantOverrides';
import useGetMerchantOverridesColumns from 'Hooks/useGetMerchantOverridesColumns';
import Table from './MerchantsOverridesTable';

const MerchantsOverridesTable = () => {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    const { isLoading, data } = useMerchantOverrides();

    const columnNames = useGetMerchantOverridesColumns({
        columns: [
            'modifiedFlag',
            'merchantId',
            'merchantName',
            'merchantDescription',
            'overallThreshold',
            'activeRules',
            'overrides',
            'lastModified',
            'status'
        ]
    });

    return <Table rawData={data} columnNames={columnNames} templateId={templateRepositoryId!} isLoading={isLoading} />;
};

export default MerchantsOverridesTable;
